<template>
    <div>
        <section>
            <div class="inner row5">
                <h1 class="boardTitle addMargin">서비스 관리</h1>
                <div>

                    <div class="searchCondition">
                        <!-- 조건 1 : 산업별 -->
                        <section class="conditionCon">
                            <div class="title">
                                <p>서비스 산업 분류(1차)</p>
                            </div>
                            <div class="conditionCategory">
                                <div v-for="(item, index) in industryList" :key="index" @click="onClickAddIndustry(item.IDX)" :class="[{selected: (selectedIndustryList.indexOf(item.IDX) > -1 && allowSelectedClass)}, {conditionCategoryItem : true}]">
                                    <div class="imgBox">
                                        <img v-bind:src="require('../../assets/images/cmmnMain/CategoryStep/icon/'+item.IMAGE)" v-bind:alt="item.IMAGE">
                                    </div>
                                    <div class="itemTitle">
                                        <p>
                                            {{item.NAME}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <!-- 조건 2 : 종류별 -->
                        <section class="conditionCon">
                            <div class="title">
                                <p>서비스 종류(2차)</p>
                            </div>
                            <div class="conditionType">
                                <div class="typeTop">
                                    <p>
                                        전체
                                        <span>
                                            ({{ serviceCount }})
                                        </span>
                                    </p>
                                </div>
                                <div class="typeBody">
                                    <div v-for="(categoryName, index) in categoryNameList" :key="index" class="typeBodyCon">
                                        <div class="title">
                                            <p>
                                                {{categoryName.NAME}}
                                            </p>
                                        </div>
                                        <div class="typeBodyItem">
                                            <div v-for="(item, itemIndex) in categoryName.ITEMS" :key="itemIndex" class="checkBoxItem" v-show="item.ITEM_COUNT > 0">
                                                <label for="one" @click="getServiceByOneCategory(item.NAME)">
                                                    {{item.NAME}} (<span> {{item.ITEM_COUNT}} </span>)
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    <div class="topContent flex searchHistoryCon mobileReset">
                        <div class="left flex flexAlignC">
                            <div class="enrollCheckBox total">
                                <input type="checkbox" v-model="selectAll">
                            </div>
                            <p>총 <span>{{ totalCnt }}</span>건</p>
                            <div class="radioContentBox">
                                <div class="radioItem">
                                    <input type="radio" id="option1" name="status" checked value="" v-model="status" @change="onChangeStatus">
                                    <label for="option1"> 전체 </label>
                                </div>
                                <div class="radioItem">
                                    <input type="radio" id="option2" name="status" value="APPROVAL" v-model="status" @change="onChangeStatus">
                                    <label for="option2"> 승인 </label>
                                </div>
                                <div class="radioItem">
                                    <input type="radio" id="option3" name="status" value="REJECT" v-model="status" @change="onChangeStatus">
                                    <label for="option3"> 거절 </label>
                                </div>
                                <div class="radioItem">
                                    <input type="radio" id="option4" name="status" value="STANDBY" v-model="status" @change="onChangeStatus">
                                    <label for="option4"> 대기 </label>
                                </div>
                            </div>
                        </div>
                        <div>
                            <input type="text" class="searchInput" v-model="searchText" @keyup.enter="onClickSearch"/>
                            <input type="button" value="검 색" class="searchBtn searchBtnCmmn" @click="onClickSearch"/>
                            <input type="button" value="검색초기화" class="searchResetBtn searchBtnCmmn" @click="onClickReset"/>
                            <div class="btnBox blankLeft inlineB">
                                <button class="greenBtn smBtn" @click="onClickEnroll">등 록</button>
                                <button class="orangeBtn smBtn" @click="onClickDelete">삭 제</button>
                            </div>
                        </div>
                    </div>

                    <div class="topContent flex searchHistoryCon mobileBlock">
                        <div class="left flex flexAlignC">
                            <div class="radioContentBox">
                                <div class="radioItem">
                                    <input type="radio" id="option1" name="status_mb" checked value="" v-model="status" @change="onChangeStatus">
                                    <label for="option1"> 전체 </label>
                                </div>
                                <div class="radioItem">
                                    <input type="radio" id="option2" name="status_mb" value="APPROVAL" v-model="status" @change="onChangeStatus">
                                    <label for="option2"> 승인 </label>
                                </div>
                                <div class="radioItem">
                                    <input type="radio" id="option3" name="status_mb" value="REJECT" v-model="status" @change="onChangeStatus">
                                    <label for="option3"> 거절 </label>
                                </div>
                                <div class="radioItem">
                                    <input type="radio" id="option4" name="status_mb" value="STANDBY" v-model="status" @change="onChangeStatus">>
                                    <label for="option4"> 대기 </label>
                                </div>
                            </div>
                        </div>
                        <div class="historySearchBox">
                            <input type="text" class="searchInput" @keyup.enter="onClickSearch"/>
                            <input type="button" value="검 색" class="searchBtn searchBtnCmmn" v-model="searchText" @click="onClickSearch"/>
                        </div>
                        <div class="flex flexAlignS historySearchBtnBox">
                            <div class="flex">
                                <div class="enrollCheckBox total">
                                    <input type="checkbox" v-model="selectAll">
                                </div>
                                <p>총 <span>{{ totalCnt }}</span>건</p>
                            </div>
                            <div class="btnBox blankLeft inlineB">
                                <button class="greenBtn smBtn" @click="onClickEnroll">등 록</button>
                                <button class="orangeBtn smBtn" @click="onClickDelete">삭 제</button>
                            </div>
                        </div>
                    </div>

                    <div class="searchResultCon">
                        <hr>
                        <div class="searchResultBody">
                            <div v-for="(service, index) in items" :key="index">
                                <div class="enrollCheckBox">
                                        <input type="checkbox" :id="'checkbox'+index" :value="service.IDX" v-model="selectedList">
                                        <div class="likeCountBox">
                                            <h5>
                                                승인
                                                <span>
                                                    {{ getStatus(service.STATUS) }}
                                                </span>
                                            </h5>
                                        </div>
                                </div>
                                <router-link :to="'/corp/serviceEnroll/'+service.SERVICE_IDX">
                                    <div class="searchResultItem">
                                        <div class="imgBox">
                                            <img :src="service.MAIN_FILE" alt="">
                                        </div>
                                        <div class="title">
                                            <p>
                                                {{service.CATEGORY_NAME}}
                                            </p>
                                        </div>
                                        <div class="subContent">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <th>생활 구분</th>
                                                        <td>{{service.LIFE}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>업체명</th>
                                                        <td>{{service.COMPANY}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>서비스명</th>
                                                        <td>{{service.NAME}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>사용제안대상</th>
                                                        <td>
                                                            <p>
                                                                {{service.TARGET}}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="tableContainer">
                        <div class="sampleTemplate">
                            <paginate
                                v-model="currentPage"
                                :page-count="navCnt"
                                :page-range="3"
                                :margin-pages="2"
                                :click-handler="onClickPagenation"
                                :prev-text="'‹'"
                                :next-text="'›'"
                                :container-class="'pagination b-pagination newPagination'">
                            </paginate>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    </div>   
</template>

<script>
import { mapActions } from 'vuex'

const REQUEST_TYPE_KEYWORD = 'KEYWORD'
const REQUEST_TYPE_CATEGORY = 'CATEGORY'

export default {
    name: 'ServiceSearch',
    computed: {
        navCnt : function(){
            if(this.totalCnt % this.perPage == 0) return this.totalCnt/this.perPage
			else return Math.floor(this.totalCnt/this.perPage) + 1;
        },
        selectAll:{
            get:function(){
                if(this.items == null || this.items.length == 0) return false
                return this.selectedList.length === this.items.length
            },
            set:function(value){
                var selectedList = []

                if(value){
                    this.items.forEach(element => {
                        selectedList.push(element.IDX)
                    })
                }

                this.selectedList = selectedList
            }
        }
    },
    data(){
        return {
            allowSelectedClass: false,
            selectedList: [],

            // for category search
            industryList: [],
            selectedIndustryList: [],
            categoryNameList : [],
            serviceCount: 0,
            categoryList: [],

            // for keyword search
            status: "",
            searchText: "",

            // service data
            requestType: REQUEST_TYPE_KEYWORD,
            items : null,
            totalCnt: 0,
            currentPage: 1,
            // service static data
            sortBy: 'IDX',
            sortDesc: false,
            perPage: 9,
        }
    },
    watch:{
        requestType(value){
            if(value === REQUEST_TYPE_CATEGORY){
                this.allowSelectedClass = true
            }
            else {
                this.selectedIndustryList = []
                this.allowSelectedClass = false
            }
        },
        selectedIndustryList(value){     
            this.categoryNameList = []
            this.serviceCount = 0
            this.categoryList = []

            this.status = ""
            this.searchText = ""

            this.items = []
            this.totalCnt = 0
            this.currentPage = 1

            if(value.length <= 0){
                return
            }

            this.getCategoryName()
        }
    },
    mounted(){
        this.requestIndustryList('SERVICE')
        .then((response) => {
            this.industryList = response.data;
        })
        .catch(() => {
            this.$alert('알림', '데이터를 가져올 수 없습니다.')
        });
        
        // 최초 로드 시 전체 데이터 검색
        this.requestType = REQUEST_TYPE_KEYWORD
        this.getService()
    },
    methods:{
        ...mapActions('category', [
            'requestIndustryList',
            'requestCorpCategoryGroupByIndustryIdxList'
        ]),
        ...mapActions('service', [
            'requestCorpServiceByKeyword',
            'requestCorpServiceByCategoryNameList',
            'deleteService'
        ]),
        getStatus(value){
            if(value === 'STANDBY') return '대기'
            else if(value === 'APPROVAL') return '완료'
            else if(value === 'REJECT') return '거절'
        },
        getCategoryName(){
            this.categoryNameList = []
            this.serviceCount = 0
            this.categoryList = []

            this.requestCorpCategoryGroupByIndustryIdxList({
                industryIdxList: this.selectedIndustryList,
                type : 'SERVICE'
            })
            .then((response)=>{
                if(response.status === 200){
                    const list = response.data
                    this.categoryNameList = list

                    for(var i = 0; i < list.length; i++){
                        const categoryList = list[i].ITEMS

                        for(var j = 0; j < categoryList.length; j++){
                            this.categoryList.push(categoryList[j])
                            this.serviceCount += categoryList[j].ITEM_COUNT
                        }
                    }

                    this.requestType = REQUEST_TYPE_CATEGORY
                    this.getService()
                }
                else{
                    this.$alert('알림', '데이터를 가져올 수 없습니다.')      
                }
            })
            .catch(()=>{
                this.$alert('알림', '통신을 실패했습니다.')  
            });
        },
        getService(){
            this.selectAll = false

            if(this.requestType === REQUEST_TYPE_CATEGORY){
                this.getServiceByCategory()
            }
            else if(this.requestType === REQUEST_TYPE_KEYWORD){
                this.getServiceByKeyword()
            }
        },
        getServiceByKeyword(){
            this.categoryNameList = []
            this.serviceCount = 0
            this.categoryList = []

            this.items = []
            this.totalCnt = 0

            this.requestCorpServiceByKeyword({
                searchText : this.searchText,
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                status: this.status
            })
            .then((result) =>{
                if(result.status === 200){
                    this.items = result.data.items;
                    this.totalCnt = result.data.totalCnt;

                    if(this.items == null){
                        this.items = [];
                        this.totalCnt = 0;
                    }
                }
                else{
                    this.$alert('알림', '데이터를 가져올 수 없습니다.')      
                }
            })
            .catch(() => {
                this.$alert('알림', '통신을 실패했습니다.')  
            })
        },
        getServiceByCategory(){
            var categoryNameList = "";
            for(var i = 0; i < this.categoryList.length; i++){
                if(this.categoryList[i].ITEM_COUNT > 0){
                    categoryNameList += this.categoryList[i].NAME + "|"
                }
            }

            if(categoryNameList === ""){
                return
            }

            this.requestCorpServiceByCategoryNameList({
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                categoryNameList : categoryNameList
            })
            .then((result) =>{
                if(result.status === 200){
                    this.items = result.data.items;
                    this.totalCnt = result.data.totalCnt;

                    if(this.items == null){
                        this.items = [];
                        this.totalCnt = 0;
                    }
                }
                else{
                    this.$alert('알림', '데이터를 가져올 수 없습니다.')      
                }
            })
            .catch(() => {
                this.$alert('알림', '통신을 실패했습니다.')  
            })
        },
        getServiceByOneCategory(categoryName){
            this.requestCorpServiceByCategoryNameList({
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                categoryNameList : categoryName
            })
            .then((result) =>{
                if(result.status === 200){
                    this.items = result.data.items;
                    this.totalCnt = result.data.totalCnt;

                    if(this.items == null){
                        this.items = [];
                        this.totalCnt = 0;
                    }
                }
                else{
                    this.$alert('알림', '데이터를 가져올 수 없습니다.')      
                }
            })
            .catch(() => {
                this.$alert('알림', '통신을 실패했습니다.')  
            })
        },
        onClickAddIndustry(idx){
            var index = this.selectedIndustryList.indexOf(idx); 
			if (index > -1) {
				this.selectedIndustryList.splice(index, 1);
			} else {
                this.selectedIndustryList.push(idx);

            }
        },
        onClickEnroll() {
            this.$router.push('/corp/serviceEnroll');
        },
        onClickDelete(){
            if(this.selectedList.length === 0){
                this.$alert('알림', '서비스를 선택해주세요.')
                return
            }

            var response = this.$createConfirmResponse()
            this.$confirm("알림", "서비스를 삭제하시겠습니까?", "확인", "취소", response, {
                'closed': () => {
                    if(response.result){
                        this.deleteService(this.selectedList)
                        .then((result) =>{
                            if(result.status === 200){
                                this.$alert('알림', '삭제되었습니다.', '확인', {
                                    'closed': () => {
                                        this.currentPage = 1
                                        this.getService()
                                    }
                                })
                            }
                            else{
                                this.$alert('알림', '서비스 삭제를 실패했습니다.')  
                            }
                        })
                        .catch(()=>{
                            this.$alert('알림', '통신을 실패했습니다.')  
                        })
                    }
                }
            })
        },
        onChangeStatus(){
            this.requestType = REQUEST_TYPE_KEYWORD
            this.currentPage = 1
            this.getService()
        },
        onClickSearch(){
            this.requestType = REQUEST_TYPE_KEYWORD
            this.currentPage = 1
            this.getService()
        },
        onClickReset(){
            this.status = ""
            this.searchText = ""
            this.currentPage = 1
            this.requestType = REQUEST_TYPE_KEYWORD
            this.getService()
        },
        onClickPagenation (pageNum) {
            this.currentPage = pageNum;
            this.getService();
        }
    },
}

</script>

<style scoped>
    a {
        color: #272727;
    }
    h3 {
        margin: 0 0 16px 0;
    }
    
</style>

<style>
</style>

